import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/trash-alt.png'
import _imports_1 from '../../../assets/filter/box-open.svg'


const _withScopeId = n => (_pushScopeId("data-v-034229c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  id: "scroll"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-row w-100 ps-3",
  id: "listaModalExcluirSelecionados"
}
const _hoisted_4 = {
  key: 1,
  class: "card d-flex flex-row align-items-end m-0 w-100",
  style: {"gap":"1.2rem !important"},
  id: "listaModalExcluirSelecionados"
}
const _hoisted_5 = {
  class: "d-flex flex-row justify-content-between w-100",
  style: {"gap":"1.2rem !important"}
}
const _hoisted_6 = {
  class: "d-flex flex-column justify-content-start",
  style: {"width":"12rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Marca", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "d-flex flex-column justify-content-start",
  style: {"width":"12rem"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filtro", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-0",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-0",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  id: "listaDoCard",
  class: "d-flex flex-column justify-content-around align-items-center w-100 mt-5 card"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5 d-flex",
  src: _imports_1,
  alt: "",
  style: {"background":"none","width":"170px"}
}, null, -1))
const _hoisted_20 = {
  class: "text-center",
  style: {"color":"#b5b5c3"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.products.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (myProd, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              id: "listaDoCard",
              class: "d-flex flex-row justify-content-between align-items-center mb-4 w-100 card p-1"
            }, [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`${myProd.referencia} ${myProd.marca} `), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("input", {
                          type: "text",
                          class: "card bg-white rounded-2 p-2",
                          style: {"border":"1px solid #b5b5c3"},
                          id: "inputt",
                          value: myProd.marca,
                          disabled: ""
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("input", {
                          type: "text",
                          class: "card bg-white rounded-2 p-2",
                          style: {"border":"1px solid #b5b5c3"},
                          id: "inputt",
                          value: myProd.referencia,
                          disabled: ""
                        }, null, 8, _hoisted_11)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "d-flex justify-content-center align-items-center m-3",
                      id: "btnModalExcluirSelecionados",
                      onClick: ($event: any) => (_ctx.$emit('removeProduto', myProd)),
                      style: _normalizeStyle(!_ctx.title ? 'margin: 0px !important' : '')
                    }, _hoisted_14, 12, _hoisted_12)
                  ])),
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "d-flex justify-content-center align-items-center m-3",
                    id: "btnModalExcluirSelecionados",
                    onClick: ($event: any) => (_ctx.$emit('removeProduto', myProd))
                  }, _hoisted_17, 8, _hoisted_15))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("h6", _hoisted_20, "Veiculo nâo possui " + _toDisplayString(_ctx.title) + " cadastrado.", 1)
        ]))
  ]))
}